import { Link } from "react-router-dom";
import { LOGO_URL, WHATSAPP_DISPLAY, WHATSAPP_URL, CONTACT_EMAIL, INSTAGRAM_URL } from "@/lib/config";
import { Mail, MapPin, Phone, Instagram, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1F150E] text-[#FAF6F0] mt-24 md:mt-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-12">
        {/* Top CTA banner */}
        <div className="text-center pb-16 border-b border-[#FAF6F0]/15">
          <p className="overline" style={{ color: "#C88B35" }}>get started</p>
          <h2 className="font-display text-5xl md:text-7xl mt-5 leading-tight italic font-light text-[#FAF6F0]">
            Start Your Tanzania<br />Adventure Today
          </h2>
          <Link to="/contact" data-testid="footer-cta-contact" className="inline-flex mt-10 btn-pill btn-pill-primary">
            Contact Us
          </Link>
        </div>

        {/* Footer columns */}
        <div className="grid md:grid-cols-4 gap-12 mt-16">
          <div className="md:col-span-2">
            <div className="flex items-center gap-4">
              <div data-testid="footer-logo" className="h-24 w-24 md:h-28 md:w-28 rounded-full overflow-hidden bg-white ring-1 ring-[#FAF6F0]/25 flex-shrink-0">
                <img
                  src={LOGO_URL}
                  alt="Apex Safaris — Experience the Spirit of Africa"
                  className="w-full h-full object-contain"
                  style={{ transform: "scale(1.35)" }}
                />
              </div>
              <div>
                <span className="block font-marcellus text-3xl text-[#FAF6F0]">Apex Safaris</span>
                <span data-testid="footer-tagline" className="block mt-1 font-display italic text-lg text-[#C88B35]">Experience the Spirit of Africa</span>
              </div>
            </div>
            <p className="mt-6 max-w-md text-sm text-[#FAF6F0]/70 leading-relaxed">
              Crafting unforgettable Tanzanian journeys since day one. From the endless plains
              of the Serengeti to the white sand of Zanzibar.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="w-10 h-10 rounded-full border border-[#FAF6F0]/25 flex items-center justify-center hover:bg-[#A6521B] hover:border-[#A6521B] transition-colors" aria-label="Instagram"><Instagram size={16} /></a>
              <a href="#" className="w-10 h-10 rounded-full border border-[#FAF6F0]/25 flex items-center justify-center hover:bg-[#A6521B] hover:border-[#A6521B] transition-colors" aria-label="Facebook"><Facebook size={16} /></a>
            </div>
          </div>

          <div>
            <h4 className="font-marcellus text-lg text-[#FAF6F0] mb-5">Explore</h4>
            <ul className="space-y-3 text-sm text-[#FAF6F0]/75">
              <li><Link to="/tours" className="hover:text-[#C88B35]" data-testid="footer-link-tours">Safari Tours</Link></li>
              <li><Link to="/gallery" className="hover:text-[#C88B35]" data-testid="footer-link-gallery">Gallery</Link></li>
              <li><Link to="/about" className="hover:text-[#C88B35]" data-testid="footer-link-about">About</Link></li>
              <li><Link to="/faq" className="hover:text-[#C88B35]" data-testid="footer-link-faq">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-[#C88B35]" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-marcellus text-lg text-[#FAF6F0] mb-5">Get in touch</h4>
            <ul className="space-y-3 text-sm text-[#FAF6F0]/75">
              <li className="flex items-start gap-3"><Phone size={15} className="mt-0.5 text-[#C88B35]" /> <a href={WHATSAPP_URL} data-testid="footer-whatsapp" className="hover:text-[#C88B35]">{WHATSAPP_DISPLAY}</a></li>
              <li className="flex items-start gap-3"><Mail size={15} className="mt-0.5 text-[#C88B35]" /> <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email" className="hover:text-[#C88B35] break-all">{CONTACT_EMAIL}</a></li>
              <li className="flex items-start gap-3"><MapPin size={15} className="mt-0.5 text-[#C88B35]" /> Arusha, Tanzania</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-[#FAF6F0]/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between text-xs text-[#FAF6F0]/50">
          <span>© {new Date().getFullYear()} Apex Safaris — All rights reserved</span>
          <span className="font-display italic">Karibu Tanzania</span>
        </div>
      </div>
    </footer>
  );
}
